import React from "react";
import "./style.css";

const IntroText = () => {
  return (
    <div className="full-window-component">
      <p className="overlay-text">
            Driving innovation  <br/> for New York City's premier <br/> infrastructure contractor 
      </p>
    </div>
  );
};

export default IntroText;
